import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { IncidentType } from '../_types/incident-type';
import { IncidentsTypesService } from '../_services/incidents-types.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-incidents-types-detail',
    templateUrl: './incidents-types-detail.component.html',
    styleUrls: ['./incidents-types-detail.component.scss'],
    standalone: false
})
export class IncidentsTypesDetailComponent {
  public incidentTypeFormGroup!: RxFormGroup;

  public incidentType: IncidentType = new IncidentType();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private incidentsTypesService: IncidentsTypesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {

    this.incidentTypeFormGroup = this.formBuilder.formGroup<IncidentType>(this.incidentType) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de tipo de incidencia");
    this.topbarService.addBreadcrumb("Tipos de incidencia", "/incidentsTypes");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadIncidentType(id);
    } else {
      let source = this.route.snapshot.params['source'];
      this.incidentType.source = source;
    }
    this.allowWrite = true; //this.loginService.hasPermission("INCIDENTS.WRITE");
    this.allowDelete = true; //this.loginService.hasPermission("INCIDENTS.DELETE");

  }

  async loadIncidentType(id: string) {
    this.incidentType = await firstValueFrom(this.incidentsTypesService.get(id));
    this.incidentTypeFormGroup.patchValue(this.incidentType);
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.incidentTypeFormGroup);
    if (valid) {
      this.incidentType = Object.assign(this.incidentType, this.incidentTypeFormGroup.value);
      let incidentType = await firstValueFrom(this.incidentsTypesService.save(this.incidentType));
      this.messageService.add({ closable: true, severity: 'success', summary: "Tipo de incidencia guardado correctamente." });
      this.router.navigate(['incidentsTypes']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tipo de incidencia?",
      header: "Eliminar tipo de incidencia",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.incidentsTypesService.delete(this.incidentType.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de incidencia eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['incidentsTypes']);
  }
}
